export default {
      id: "delivery-plane-usage",
      viewBox: "0 0 35 30",
      url: __webpack_public_path__ + "svg-sprite-defs.svg#delivery-plane",
      toString: function () {
        return this.url;
      }
    }